import { clsx } from 'clsx';

import { Fragment } from 'react';

import { Typography } from '@monoimin/atoms';
import { CardProps } from '@monoimin/sb-types';

import { IconWithCaption } from '@monoimin/molecules/IconWithCaption';

function CardFooter({
  caption,
  icon,
  iconCaption,
  classNames,
  readingTime,
  date,
}: Pick<
  CardProps,
  'caption' | 'icon' | 'iconCaption' | 'classNames' | 'date' | 'readingTime'
>) {
  const haveValidIconWithCaption = iconCaption && icon;
  const allowRenderingDetails = date && readingTime;

  const allowRenderingFooter =
    caption || haveValidIconWithCaption || allowRenderingDetails;

  const captionBlock = (
    <Fragment>
      <Typography
        className={clsx('caption font-bold text-blue-500 relative', {
          'dot-after-small-gap': haveValidIconWithCaption,
        })}
      >
        {caption}
      </Typography>
      {haveValidIconWithCaption && (
        <IconWithCaption caption={iconCaption!} icon={icon!} />
      )}
    </Fragment>
  );

  const detailsBlock = (
    <Fragment>
      <IconWithCaption caption={readingTime!} icon='clock' />
      <IconWithCaption caption={date!} icon='calendar' />
    </Fragment>
  );

  return (
    allowRenderingFooter && (
      <div
        className={clsx('flex flex-wrap gap-4 mt-9', classNames?.footer, {
          'justify-between': allowRenderingDetails && readingTime,
          'justify-end': allowRenderingDetails && !readingTime,
        })}
      >
        {allowRenderingDetails ? detailsBlock : captionBlock}
      </div>
    )
  );
}

export default CardFooter;
